import React, { type FC } from "react";
import { useTrackElement } from "@edreamsodigeo/frontend-core";
import { Button } from "@edreamsodigeo/prisma-design-system";

import type { ButtonTextProps } from "./contract";

const ButtonText: FC<ButtonTextProps> = ({
  children,
  onClick,
  type = "text",
  trackingId = "",
  dataTestId,
}) => {
  const clickTrackingRef = useTrackElement<HTMLButtonElement>(
    ["click"],
    trackingId,
  );

  return (
    <Button
      data-testid={dataTestId}
      type={type}
      sx={{ fontSize: "body.1", width: "100%" }}
      aria-label="Login button type text"
      onClick={onClick}
      {...(trackingId && { ref: clickTrackingRef })}
    >
      {children}
    </Button>
  );
};

export default ButtonText;
